"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numericOperators = void 0;
exports.numericOperators = {
    "$lt": (data, value) => {
        let processedData = data;
        if (typeof data === "string") {
            // Remove commas and parse as float
            processedData = parseFloat(data.replace(/[$,]/g, ""));
        }
        if (typeof processedData !== "number") {
            return false;
        }
        if (isNaN(processedData)) {
            return false;
        }
        return value !== null && value !== undefined && processedData < value;
    },
    "$lte": (data, value) => {
        let processedData = data;
        if (typeof data === "string") {
            // Remove commas and parse as float
            processedData = parseFloat(data.replace(/[$,]/g, ""));
        }
        if (typeof processedData !== "number") {
            return false;
        }
        if (isNaN(processedData)) {
            return false;
        }
        return value !== null && value !== undefined && processedData <= value;
    },
    "$gt": (data, value) => {
        let processedData = data;
        if (typeof data === "string") {
            // Remove commas and parse as float
            processedData = parseFloat(data.replace(/[$,]/g, ""));
        }
        if (typeof processedData !== "number") {
            return false;
        }
        if (isNaN(processedData)) {
            return false;
        }
        return value !== null && value !== undefined && processedData > value;
    },
    "$gte": (data, value) => {
        let processedData = data;
        if (typeof data === "string") {
            // Remove commas and parse as float
            processedData = parseFloat(data.replace(/[$,]/g, ""));
        }
        if (typeof processedData !== "number") {
            return false;
        }
        if (isNaN(processedData)) {
            return false;
        }
        return value !== null && value !== undefined && processedData >= value;
    },
    "$between": (data, value) => {
        let processedData = data;
        if (typeof data === "string") {
            processedData = parseFloat(data);
        }
        if (typeof processedData !== "number") {
            return false;
        }
        if (isNaN(processedData)) {
            return false;
        }
        // check if value is an array of length two
        if (!Array.isArray(value) || value.length !== 2) {
            return false;
        }
        // check if value[0] and value[1] are numbers
        if (typeof value[0] !== "number" ||
            typeof value[1] !== "number" ||
            isNaN(value[0]) ||
            isNaN(value[1])) {
            return false;
        }
        // check if value[0] is less than value[1]
        if (value[0] > value[1]) {
            return false;
        }
        // check if data is a number
        if (processedData === null ||
            processedData === undefined ||
            typeof processedData !== "number" ||
            isNaN(processedData)) {
            return false;
        }
        return processedData >= value[0] && processedData <= value[1];
    }
};
//# sourceMappingURL=numeric.js.map